import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { debounceTime } from 'rxjs/operators';
import { TextFavorite, TextFavoriteType } from 'src/API';
import { noSort } from 'src/app/core/api/model-utils';
import { StaffService } from 'src/app/core/api/staff.service';
import { defaultTextFavoriteMap } from '../text-favorite-model';
import { TextFavoriteSetupActionsModalComponent } from '../text-favorite-setup-actions-modal/text-favorite-setup-actions-modal.component';
import { TextFavoriteService } from './../text-favorite.service';

@Component({
  selector: 'csi-text-favorite-select',
  templateUrl: './text-favorite-select.component.html',
  styleUrls: ['./text-favorite-select.component.css']
})
export class TextFavoriteSelectComponent implements OnInit {
  public filterControl: FormControl = new FormControl();
  public favoritesForType: TextFavorite[] = [];
  public filteredFavorites: TextFavorite[] = [];
  public selectedFavoritesMap: Record<string, TextFavorite> = {};
  public selectedFavorites: TextFavorite[] = [];

  public matSelectHeaders: {
    [key: string]: { name: string; conditionToShow: TextFavoriteType };
  } = {
    shortCut: { name: 'Shortcut', conditionToShow: TextFavoriteType.Recommendations },
    treatMentTemplateID: {
      name: 'Treatment Template ID',
      conditionToShow: TextFavoriteType.Recommendations
    },
    Text: { name: 'Text', conditionToShow: TextFavoriteType.Recommendations }
  };

  public TextFavoriteType = TextFavoriteType;

  constructor(
    private textFavoriteService: TextFavoriteService,
    @Inject(MAT_DIALOG_DATA) public textFavoriteType: TextFavoriteType,
    public staffService: StaffService,
    private dialog: MatDialog
  ) {
    this.favoritesForType = this.textFavoriteService.getTextFavoritesForType(this.textFavoriteType);
    this.updateFilteredFavorites();

    this.filterControl.valueChanges.pipe(debounceTime(100)).subscribe((filter: string) => {
      this.updateFilteredFavorites(filter);
    });
  }

  defaultTextFavoriteMap = defaultTextFavoriteMap;

  ngOnInit() {}

  openTextFavoriteEditModal(textFavorite: TextFavorite, event: Event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    this.dialog
      .open(TextFavoriteSetupActionsModalComponent, {
        width: '75vw',
        data: {
          action: defaultTextFavoriteMap[textFavorite.id] ? 'copy' : 'update',
          textFavorite,
          type: textFavorite.type
        }
      })
      .afterClosed()
      .subscribe(() => {
        this.favoritesForType = this.textFavoriteService.getTextFavoritesForType(
          this.textFavoriteType
        );
        this.updateFilteredFavorites();
      });
  }

  openTextFavoriteModalToAdd(textFavorite: TextFavorite, event: Event) {
    this.dialog
      .open(TextFavoriteSetupActionsModalComponent, {
        width: '75vw',
        data: {
          action: 'add',
          textFavorite,
          type: this.textFavoriteType
        }
      })
      .afterClosed()
      .subscribe(() => {
        this.favoritesForType = this.textFavoriteService.getTextFavoritesForType(
          this.textFavoriteType
        );
        this.updateFilteredFavorites();
      });
  }

  addSelectedFavorites(selectedFavorite: TextFavorite) {
    if (this.selectedFavoritesMap[selectedFavorite.shortcut]) {
      delete this.selectedFavoritesMap[selectedFavorite.shortcut];
    } else {
      this.selectedFavoritesMap[selectedFavorite.shortcut] = selectedFavorite;
    }
    this.selectedFavorites = Object.values(this.selectedFavoritesMap);
  }

  private updateFilteredFavorites(filter: string = ''): void {
    const lowerCaseFilter = filter.toLowerCase();

    const userCreatedFavorites = this.favoritesForType.filter(favorite => favorite.createdAt);

    const otherFavorites = this.favoritesForType.filter(favorite => !favorite.createdAt);

    const filteredUserCreatedFavorites = userCreatedFavorites.filter(
      favorite =>
        (favorite.shortcut && favorite.shortcut.toLowerCase().includes(lowerCaseFilter)) ||
        (favorite.text && favorite.text.toLowerCase().includes(lowerCaseFilter)) ||
        (favorite.treatmentTemplate &&
          favorite.treatmentTemplate.friendlyId &&
          favorite.treatmentTemplate.friendlyId.toLowerCase().includes(lowerCaseFilter))
    );

    const filteredOtherFavorites = otherFavorites.filter(
      favorite =>
        (favorite.shortcut && favorite.shortcut.toLowerCase().includes(lowerCaseFilter)) ||
        (favorite.text && favorite.text.toLowerCase().includes(lowerCaseFilter)) ||
        (favorite.treatmentTemplate &&
          favorite.treatmentTemplate.friendlyId &&
          favorite.treatmentTemplate.friendlyId.toLowerCase().includes(lowerCaseFilter))
    );

    this.filteredFavorites = [...filteredUserCreatedFavorites, ...filteredOtherFavorites].sort(
      (a, b) =>
        (this.textFavoriteService.textFavoriteConfig.value[this.textFavoriteType] || []).findIndex(
          textFav => textFav.id === a.id
        ) -
        (this.textFavoriteService.textFavoriteConfig.value[this.textFavoriteType] || []).findIndex(
          textFav => textFav.id === b.id
        )
    );
  }
  noSort = noSort;
}
